/**
 * A photo URL safe to show: one of our uploaded images or any https link
 * (older pages use pasted Google Drive links). Anything else is ignored.
 */
export function safePhoto(url?: string | null): string | undefined {
  if (!url) return undefined;
  return url.startsWith("https://") ||
    url.startsWith(`${process.env.REACT_APP_BACKEND_API_DOMAIN}/images/`)
    ? url
    : undefined;
}
